<div class="cb-margin-top cb-margin-bottom start flex-col">
    <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row">
        <mat-icon>hotel</mat-icon>
        <div class="custom-slider">
            <ngx-slider [(value)]="searchData.numberOfBedrooms"
                        [options]="optionsBedRoom"
                        [(ngModel)]="searchData.numberOfBedrooms"></ngx-slider>
        </div>
    </div>
    <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row">
        <mat-icon>wc</mat-icon>
        <div class="custom-slider">
            <ngx-slider [(value)]="searchData.numberOfBathrooms"
                        [options]="optionsBathRoom"
                        [(ngModel)]="searchData.numberOfBathrooms"></ngx-slider>
        </div>
    </div>
    <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row">
        <mat-icon>weekend</mat-icon>
        <div class="custom-slider">
            <ngx-slider [(value)]="searchData.numberOfLivingRooms"
                        [options]="optionsLiving"
                        [(ngModel)]="searchData.numberOfLivingRooms"></ngx-slider>
        </div>
    </div>
    <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row">
        <mat-icon>directions_car</mat-icon>
        <mat-form-field>
            <mat-label>Garages</mat-label>
            <mat-select [(ngModel)]="searchData.numberOfGarages">
                @for (type of garageTypes; track type) {
                    <mat-option
                        [value]="type.id">
                        {{ type.label }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    @if (optionsBuildCostLoaded && costs) {
        <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row"
        >
            <mat-icon matTooltip="Price">attach_money</mat-icon>
            <div class="custom-slider">
                <ngx-slider [(value)]="minCost"
                            [(highValue)]="maxCost"
                            [options]="optionsBuildCost"
                            (userChangeEnd)="rangerValueChange($event,'Cost')"></ngx-slider>
            </div>
        </div>
    }
    @if (optionsFloorAreaLoaded && areas) {
        <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start-center flex-row"
        >
            <mat-icon matTooltip="Floor Area">border_clear</mat-icon>
            <div class="custom-slider">
                <ngx-slider [(value)]="minFloorArea"
                            [(highValue)]="maxFloorArea"
                            [options]="optionsFloorArea"
                            (userChangeEnd)="rangerValueChange($event,'FloorArea')"></ngx-slider>
            </div>
        </div>
    }
    <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-2x start left flex-row">
        <mat-slide-toggle [checked]="searchData.showUnpublished"
                          [(ngModel)]="searchData.showUnpublished">
            Show Unpublished
        </mat-slide-toggle>
    </div>
    <footer class="cb-margin-left-2x cb-margin-right-2x flex-row">
        <div class="flex"></div>
        <button mat-raised-button
                (click)="clearSearch()">
            <mat-icon>clear_all</mat-icon>
            &nbsp;Clear Filter
        </button>
    </footer>
</div>
